module.exports = __webpack_public_path__ + "img/awaeds-bottom.0661054e.svg";